<button (click)="toggleInternal(false)" class="no-select" id="buttonExternal" [ngClass]="{ selected: !wallsHidden }">
  <div class="button-text">
    {{ 'OUTSIDEVIEW' | translate }}
  </div>
</button>
<button (click)="toggleInternal(true)" class="no-select" id="buttonInternal" [ngClass]="{ selected: wallsHidden }">
  <div class="button-text">
    {{ 'INSIDEVIEW' | translate }}
  </div>
</button>
